<template>
  <template v-for="property of nonDefaultCulturalProperties" :key="property.defaultHeader">
    <PropertyComparisonProvider :property="property" :comparisons="comparisons">
      <template #default="{ compareBasis, compareTo, containsChanges }">
        <div v-if="containsChanges" class="d-flex">
          <PropertyLabelComponent :property="property" disabled />:
          <div class="ml-2" />
          <TinyPropertyStateChangeComponent contains-changes :original="compareBasis" :current="compareTo" show-changes />
        </div>
      </template>
    </PropertyComparisonProvider>
  </template>
</template>

<script setup lang="ts">
import { useSelectedProperties } from '@/composables/useSelectedProperties'
import { Comparison } from '@/models/Property'
import { onMounted } from 'vue'
import PropertyComparisonProvider from './PropertyComparisonProvider.vue'
import PropertyLabelComponent from './PropertyLabelComponent.vue'
import TinyPropertyStateChangeComponent from './TinyPropertyStateChangeComponent.vue'

const props = defineProps<{ comparisons: Comparison[] }>()
const { nonDefaultCulturalProperties, initProperties } = useSelectedProperties('products')

onMounted(() => {
  initProperties()
})
</script>

<style lang="scss" scoped></style>
